export default __webpack_public_path__ + "static/media/princeofterror.d2b5d7ba.png";